/*
 * Free shipping bar in the cart drawer.
 *
 * Every cart update swaps the drawer's HTML wholesale, so the bar arrives
 * already at its new width and a CSS transition has nothing to animate from.
 * Each new bar therefore starts at the width the previous one had and slides
 * from there; the message fades in when it changes.
 */
(function () {
  if (customElements.get('cart-shipping-progress')) return;

  // With an empty cart there is no bar yet, so the first one grows from zero.
  let lastProgress = document.querySelector('cart-shipping-progress') ? null : 0;
  let lastMessage = null;

  class CartShippingProgress extends HTMLElement {
    connectedCallback() {
      const target = parseFloat(this.dataset.progress) || 0;
      const fill = this.querySelector('[data-shipping-fill]');
      const text = this.querySelector('[data-shipping-text]');
      const message = text ? text.textContent.trim() : '';

      const previous = lastProgress;
      const previousMessage = lastMessage;
      lastProgress = target;
      lastMessage = message;

      // First render on this page: nothing to animate from.
      if (previous === null) return;

      // A drawer that is about to slide in would hide most of the animation,
      // so give it time to open first.
      const drawer = this.closest('cart-drawer');
      const delay = drawer && !drawer.classList.contains('active') ? 350 : 0;

      if (text && message !== previousMessage) {
        text.classList.add('is-entering');
        text.addEventListener('animationend', () => text.classList.remove('is-entering'), { once: true });
      }

      if (target >= 100 && previous < 100) {
        this.classList.add('is-celebrating');
        setTimeout(() => this.classList.remove('is-celebrating'), delay + 1400);
      }

      if (!fill || previous === target) return;

      fill.style.transition = 'none';
      fill.style.width = `${previous}%`;
      // Commit the old width before animating away from it.
      void fill.offsetWidth;
      fill.style.transition = '';

      setTimeout(() => {
        requestAnimationFrame(() => {
          fill.style.width = `${target}%`;
        });
      }, delay);
    }

    disconnectedCallback() {
      // An update puts the next bar in straight away. If none came, the cart
      // was emptied, and the next bar should grow from nothing.
      queueMicrotask(() => {
        if (!document.querySelector('cart-shipping-progress')) {
          lastProgress = 0;
          lastMessage = null;
        }
      });
    }
  }

  customElements.define('cart-shipping-progress', CartShippingProgress);
})();
